import 'source/public_path';
import 'source/global';
import 'url-search-params-polyfill';

import IDRouter from './router';

const router = new IDRouter();
window.router = router;

export default router;



// WEBPACK FOOTER //
// ./authentication/static-source/js/authentication/app.js